<template>
    <DefaultLayout>
        <div class="container">
            <h1 style="margin-bottom: -40px;">Adquirir Producto</h1>
            <div class="cards">
                <div class="card">
                    <form class="inputProfile">
                        <h4>{{ course?.name }}</h4>
                        <br>
                        <img :src="course?.imageURL" alt="course" style="max-width: 200px;height: auto;">
                        <br>
                        <h5>Coste total</h5>
                        <p class="price-discount">{{ course?.price }} {{ course?.currency?.symbol }}</p>
                    </form>
                    <br>
                    <div id="paypal-button-container-month" style="z-index: 0;"></div>
                </div>
            </div>
            <br>
            <div class="title">Muchas gracias por confiar<br> en nosotros.</div>
        </div>
    </DefaultLayout>
</template>

<script lang="ts" setup>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { onMounted, ref, Ref } from 'vue';
import PayPalService from '@/services/PayPalService';
import ProfileService from '@/services/ProfileService';
import { loadScript } from '@paypal/paypal-js';
import { useAuth } from '@/store/useAuth';
import CourseService from '@/services/CourseService';
import main from '@/data/main.js';
import { useRoute } from 'vue-router';
import OrderService from '@/services/OrderService';
import OrderI from '@/interfaces/OrderInterface';

const service = new PayPalService();
const userService = new ProfileService();
const store = useAuth();
const data = ref({});
const user = ref({});
const route = useRoute();
const courseService = new CourseService();
const course_id = route.params.id;
const course: Ref<any> = ref({});
const orderService = new OrderService();
const orderDTO: Ref<OrderI> = ref({});

onMounted(async () => {
    if (!store.token) {
        return;
    }

    course.value = await courseService.GetCourse(course_id);
    if (!course.value || !course.value.currency) {
        console.error('El curso o su moneda no están definidos correctamente.');
        return;
    }

    user.value = await userService.MyUser(store.token);

    const paypalSdk = await loadScript({
        clientId: main.PAYPAL_ID_CLIENT,
        currency: course.value.currency.code,
        vault: true
    });

    if (paypalSdk) {
        const paypalButtons = paypalSdk.Buttons;
        if (paypalButtons) {
            paypalButtons({
                createOrder: async function (data, actions) {
                    const rawResponse = await orderService.createOrder(store.token, course.value.id);
                    const response = await rawResponse.json();
                    if (!response.success) {
                        alert("error");
                    }
                    orderDTO.value = response.data;
                    return actions.order.create({
                        intent: 'CAPTURE',
                        purchase_units: [{
                            amount: {
                                currency_code: course.value.currency.code,
                                value: course.value.price
                            }
                        }]
                    });
                },
                onApprove: async function (data, actions) {
                    await orderService.completeOrder(store.token, orderDTO.value.id);
                    window.location.assign(`compra-realizada`);
                },
                onCancel: async function (data, actions) {
                    await orderService.cancelOrder(store.token, orderDTO.value.id);
                    alert("Compra cancelada");
                }
            }).render('#paypal-button-container-month');
        } else {
            console.error('La función Buttons() no está disponible en el objeto PayPalSdk.');
        }
    } else {
        console.error('El objeto PayPalSdk es nulo.');
    }
});
</script>


<style lang="scss" scoped>
.buttons {
    display: flex;

}

.price {
    display: flex;
}

.price-original {
    color: red;
    text-decoration: line-through;
}

.price-discount {
    color: #29c682;
}

.separator {
    width: 10px;
}

.cards {
    display: flex;
}

h1 {
    margin-top: 20px;
    margin-bottom: 20px;
}

strong {
    color: #28a3bf !important;
}

h4 {
    margin-bottom: 10px;
}

.inputView {
    margin-bottom: 15px;
}


.container {
    margin-bottom: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    text-align: center;

}

.inputProfile {
    flex-direction: column;
    width: 60%;
    display: flex;
    align-items: center;
}

.card {
    padding: 15px;
    min-height: 300px;
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 10px;
    margin: 15px;
    margin-top: 60px;
    background-color: white;
    box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.1);

}


.btn-details {
    margin-top: 15px;
    padding: 10px;
    color: white;
    background-color: $secondary-color;
    font-size: 13px;
    border-radius: 5px;
    border: none;
    text-decoration: none;
    margin-bottom: 5px;
    font-family: $main-font;
    min-width: 100px;
}

b {
    color: white;
}

.btn-details:hover {
    background-color: $third-color;
    cursor: pointer;
    scale: 1.1;
}

@media screen and (max-width: 600px) {
    .inputProfile {
        width: 100%;
    }

    .container {
        background-image: none !important;
        /* Oculta las imágenes de fondo en dispositivos móviles */
    }

    .card {
        width: 100%;
        margin-left: 0;

    }

    .cards {
        flex-direction: column;
    }
}
</style>